import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import { Button } from '~/components/Atoms/Button'
import { IconBox } from '~/components/Atoms/IconBox'
import { Tag } from '~/components/Atoms/Tag'

const MANAGER_TRAINING_PDF_URL = 'https://5052259.fs1.hubspotusercontent-na1.net/hubfs/5052259/Formation%20managers.pdf'

export function ManagerTrainingCard() {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Box
      display="flex"
      flexDirection="column"
      padding={theme.spacing.XXL}
      gap={theme.spacing.L}
      borderRadius={theme.radius.M}
      bgcolor={theme.palette.primary.lighter}
    >
      <Box display="flex" gap={theme.spacing.L} alignItems="center">
        <IconBox icon={<SchoolOutlinedIcon />} />
        <Typography variant="h3">{t('home:managerTraining.title')}</Typography>
        <Tag label={t('home:report.new')} typoVariant="caption" />
      </Box>
      <Typography variant="body">{t('home:managerTraining.content')}</Typography>
      <Typography variant="body">{t('home:managerTraining.csm')}</Typography>
      <Box display="flex" justifyContent="flex-end">
        <Button
          label={t('home:managerTraining.download')}
          variant="outlined"
          startIcon={<DownloadOutlinedIcon />}
          component="a"
          href={MANAGER_TRAINING_PDF_URL}
          target="_blank"
          rel="noopener noreferrer"
        />
      </Box>
    </Box>
  )
}
